import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import isNil from 'lodash-es/isNil';
import { gql } from '@yi/core';

import { SeriesPageContext } from '~/src/common/lean-back';
import { usePageContext } from '~/src/components/PageContextProvider';

import { getEpisodesOrder } from './getEpisodesOrder';

export function useEpisodesList() {
  const { seriesId } = usePageContext<SeriesPageContext>();
  const { error, data, loading } = useQuery<
    gql.typesClient.Query_Series,
    gql.typesClient.Query_SeriesVariables
  >(gql.Query_Series, {
    variables: { id: seriesId },
    fetchPolicy: 'cache-and-network',
  });

  const episodesList = useMemo(() => {
    if (isNil(data) || loading || error) {
      return {
        episodesOrder: [],
      };
    }
    return {
      episodesOrder: getEpisodesOrder(data),
    };
  }, [data, error, loading]);
  return episodesList;
}
